import { render, staticRenderFns } from "./CardInstance.vue?vue&type=template&id=024e751e"
import script from "./CardInstance.vue?vue&type=script&lang=js"
export * from "./CardInstance.vue?vue&type=script&lang=js"
import style0 from "./CardInstance.vue?vue&type=style&index=0&id=024e751e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports